import Lenis from "@studio-freight/lenis";

import { header } from './modules/header';
import { animation } from './modules/animation';

header();
animation();

document.addEventListener("DOMContentLoaded", () => {
const lenis = new Lenis({
  smoothTouch: true,
});

window.lenis = lenis;

// RAF
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


// ====== 白背景セクションを取得 ======
const header = document.querySelector('header');
const bgWhiteSections = document.querySelectorAll('.js-bgWhite');

// ====== Lenis の scroll イベントで判定 ======
lenis.on('scroll', () => {
  const scrollY = lenis.scroll; // 現在のスクロール位置
  let inWhiteSection = false;

  bgWhiteSections.forEach(section => {
    const sectionTop = section.offsetTop;
    const sectionBottom = sectionTop + section.offsetHeight;

    if (scrollY >= sectionTop && scrollY < sectionBottom) {
      inWhiteSection = true;
    }
  });

  // 1つでも白背景セクション内にいれば dark を付与
  if (inWhiteSection) {
    header.classList.add('dark');
  } else {
    header.classList.remove('dark');
  }
});
// ------------------------------------------
// ★ アンカーリンク対応
// ------------------------------------------
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    const href = anchor.getAttribute("href");

    // href="#" は無視
    if (href === "#" || href === "") return;

    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault(); // デフォルトの瞬間移動をキャンセル

    // Lenis でふわっと移動
    lenis.scrollTo(target, {
      duration: 1.2,       // スクロール時間（好みで変更）
      easing: (x) => 1 - Math.pow(1 - x, 3), // しっとり減速カーブ
    });
  });
});



  // 768px以下のみ動かす
  function initAccordionForMobile() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const toggles = document.querySelectorAll(".navcls-toggle");

    // PCの場合はアコーディオン解除
    if (!isMobile) {
      toggles.forEach((toggle) => {
        const content = toggle.nextElementSibling;
        if (content && content.classList.contains("navcls-cont")) {
          content.style.maxHeight = null;
          content.classList.remove("active");
        }
      });
      return;
    }

    // スマホ時のみアコーディオン有効
    toggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const content = toggle.nextElementSibling;

        if (!content || !content.classList.contains("navcls-cont")) return;

        // アコーディオンが開いているかどうか
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          toggle.classList.remove("active");
        } else {
          // 他のアコーディオンを閉じる（任意）
          document.querySelectorAll(".navcls-cont").forEach((other) => {
            if (other !== content) {
              other.style.maxHeight = null;
              other.previousElementSibling?.classList.remove("active");
            }
          });

          content.style.maxHeight = content.scrollHeight + "px";
          toggle.classList.add("active");
        }
      });
    });
  }

  // 初期化
  initAccordionForMobile();

  // リサイズ時にも判定を再実行
  window.addEventListener("resize", initAccordionForMobile);

});
